import { PlanungLookupProjekte } from '@/types/service-response'

export class CommissionLookupProject {
  private constructor (
    readonly id: number,
    readonly nummer: string | null,
    readonly titel: string | null,
    readonly adressNummer: string | null,
    readonly adressLinie: string | null,
    readonly label: string
  ) {}

  public static createListFromResponse (data: PlanungLookupProjekte[]): CommissionLookupProject[] {
    return data.map((item: PlanungLookupProjekte): CommissionLookupProject => {
      return new CommissionLookupProject(
        item.ID,
        item.Nummer,
        item.Titel,
        item.AdressNummer,
        item.AdressLinie,
        `${item.Nummer} / ${item.Titel}`
      )
    })
  }
}
